namespace JupitersChoice {
    export class CheckMegaReelCmd {

        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const spinInfo = this._stateModel.currentSubgame === 'FreeGame' ?
                response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;

            if (!spinInfo.megareelStrips) {
                this._eventManager.publish('onHasNoMegaReel');
            } else {
                this._eventManager.publish('onHasMegaReel');
            }
        }
    }
}